import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { User } from '../models';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<User[]>(`${environment.apiUrl}/users`);
    }

    getProfile() {
        return this.http.get<any>(`${environment.apiUrl}/employee/employee/profile`)
    }

    getProfileId(userId:any) {
        return this.http.get<any>(`${environment.apiUrl}/employee/employee/${userId}`)
    }

    updateProfile(data:any){
        return this.http.patch<any>(`${environment.apiUrl}/employee/employee/profile`, data)
    }

    updatePassword(data:any){
        return this.http.post<any>(`${environment.apiUrl}/auth/change-password`, data)
    }

    friendRequest(data:any){
        return this.http.post<any>(`${environment.apiUrl}/user/friend_request`, data)
    }
    getRequest(perPage:number, page:number){
        return this.http.get<any>(`${environment.apiUrl}/user/friend_request?perPage=${perPage}&page=${page}`)
    }
    patchRequest(id:string, data:any){
        return this.http.patch<any>(`${environment.apiUrl}/user/friend_request/${id}`, data)
    }

    getAllDepartment() {
        return this.http.get<any>(`${environment.apiUrl}/department/department?page=1&perPage=-1`)
    }

    getDepartment(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/department/department?perPage=${perPage}&page=${page}`)
    }

    getDepartmentId(id:any) {
        return this.http.get<any>(`${environment.apiUrl}/department/department/${id}?work_status=0`)
    }
    getBirthday(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/employee/employee/birthday?perPage=${perPage}&page=${page}`)
    }
    getEmployee(perPage:number, page:number, params:any){
        return this.http.get<any>(`${environment.apiUrl}/employee/employee?perPage=${perPage}&page=${page}&${params}`)
    }
    getAllEmployee(perPage:number, page:number){
        return this.http.get<any>(`${environment.apiUrl}/employee/employee?perPage=${perPage}&page=${page}&work_status=0`)
    }
    getContractEmployee(id:string) {
        return this.http.get<any>(`${environment.apiUrl}/contract/contract/?employee=${id}`)
    }
    getContractId(id:string) {
        return this.http.get<any>(`${environment.apiUrl}/contract/contract/${id}`)
    }
    exportContract(id:string) {
        return this.http.get<any>(`${environment.apiUrl}/contract/contract/export/${id}`)
    }
    getTimekeeping(id:string, from:any, to:any) {
        return this.http.get<any>(`${environment.apiUrl}/employee/timekeeping/?employee=${id}&from=${from}&to=${to}`)
    }
}